import React, { useState } from 'react';
import { FoundationsButton } from '../../GenericComponents/button';
import GenericTableforArrayofObjects from '../../GenericComponents/GenericTableforArrayofObjects';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../Redux/store';
import { CreateMetadataDrillThru, EditMetadataDrillThru } from '../../Redux/Admin_Tasks/MDSSlice';
import { getBaseUrl } from '../../Utils';
import { FoundationsEnums } from '../../FoundationsEnums';
import { text } from 'stream/consumers';

const ConfirmationPage: React.FC<{ CombinedData: any; handleBackToForm: () => void, isEdit?: boolean }> = ({ CombinedData, handleBackToForm, isEdit }) => {
    const dispatch: AppDispatch = useDispatch();
    const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' | null }>({ text: '', type: null });
    const selectedColumnsDisplay = CombinedData.drillThruSetColumns?.map((col: any) => col.FieldName).join(', ');
    const tableData = [
        { Field: 'DrillThru Set Name', Value: CombinedData.Name || 'None' },
        { Field: 'DrillThru Type', Value: CombinedData.DrillThruType || 'None' },
        //{ Field: 'Selected Measure', Value: CombinedData.fieldName || 'None' },
        { Field: 'Allow DrillThru Search', Value: CombinedData.IsSearchAllowed ? 'Yes' : 'No' },
        { Field: 'Is Default', Value: CombinedData.IsDefault ? 'Yes' : 'No' },
        { Field: 'Visible', Value: CombinedData.Visible ? 'Yes' : 'No' },
        { Field: 'Sort Columns', Value: CombinedData.SortColumnsForOrderBy ? JSON.stringify(CombinedData.SortColumnsForOrderBy) : 'None' },
        { Field: 'Additional Buttons', Value: CombinedData.AdditionalButtons || 'None' },
        { Field: 'Selected Columns', Value: selectedColumnsDisplay || 'None' },
    ];


    function formatValue(value: any): string {
        if (value === null || value === undefined) {
            return '';
        } else if (typeof value === 'boolean') {
            return value ? 'true' : 'false';
        } else if (value instanceof Date) {
            return value.toISOString();
        } else {
            return String(value);
        }
    }
    const handleConfirm = async () => {
        const formData = new FormData();

        formData.append('Id', CombinedData.Id ?? '');
        formData.append('HLSysType', CombinedData.Name ?? '');
        formData.append('Name', CombinedData.Name ?? '');
        formData.append('FieldName', CombinedData.FieldName ?? '');
        formData.append('FactGroupName', CombinedData.FactGroupName ?? '');
        formData.append('DrillThruType', CombinedData.DrillThruType ?? '');
        formData.append('FromTableQuery', CombinedData.FromTableQuery ?? '');
        formData.append('FieldKey', CombinedData.FieldKey ?? '');
        formData.append('DefaultAliasName', CombinedData.DefaultAliasName ?? '');
        formData.append('IsDefault', (CombinedData.IsDefault ? 1 : 0).toString())
        formData.append('CreatedOn', new Date(Date.now()).toISOString());
        formData.append('LastUpdatedOn', CombinedData.LastUpdatedOn ? new Date(CombinedData.LastUpdatedOn).toISOString() : '');
        formData.append('RenderMode', CombinedData.RenderMode ?? '');
        formData.append('AdditionalButtons', CombinedData.AdditionalButtons ?? '');
        formData.append('IsSearchAllowed', (CombinedData.IsSearchAllowed ?? '').toString());
        formData.append('IsColumnSearchAllowed', (CombinedData.IsColumnSearchAllowed ?? '').toString());
        formData.append('Visible', (CombinedData.Visible ?? '').toString());
        formData.append('MeasureId', CombinedData.MeasureId ?? '');
        formData.append('fk_FactTable', CombinedData.fk_FactTable ?? -1);
        formData.append('Fk_DrillThruType', CombinedData.Fk_DrillThruTypeId ?? '');

        ['drillThruSetColumns', 'SortColumnsForOrderBy'].forEach(arrayField => {
            if (Array.isArray(CombinedData[arrayField])) {
                CombinedData[arrayField].forEach((item, index) => {
                    Object.entries(item).forEach(([key, value]) => {
                        formData.append(`${arrayField}[${index}][${key}]`, formatValue(value));
                    });
                });
            } else {
                console.warn(`${arrayField} is not an array or is undefined`);
            }
        });
        try {
            let response;
            if (isEdit) {
                response = await dispatch(EditMetadataDrillThru(formData)).unwrap();
                if (response.data.MessageResults.length > 0) {
                    for (let i = 0; i < response.data.MessageResults.length; i++) {
                        if (response.data.value == true ||
                            response.data.MessageResults[i].HelpMessage ==
                            FoundationsEnums.Status.Success
                        ) {
                            setMessage({ text: "Drill-Thru Set Updated Successfully.", type: "success" })
                        } else {
                            setMessage({ text: response.data.MessageResults[i], type: "error" })
                        }
                    }
                } else if (response.data.value == true) {
                    setMessage({ text: "Drill-Thru Set Updated Successfully.", type: "success" })
                }
            } else {
                response = await dispatch(CreateMetadataDrillThru(formData)).unwrap();
                if (response.data.MessageResults.length > 0) {
                    for (let i = 0; i < response.data.MessageResults.length; i++) {
                        if (response.data.value == true ||
                            response.data.MessageResults[i].HelpMessage ==
                            FoundationsEnums.Status.Success
                        ) {
                            setMessage({ text: "Drill-Thru Set Created Successfully.", type: "success" })
                        } else {
                            setMessage({ text: response.data.MessageResults[i], type: "error" })
                        }
                    }
                } else if (response.data.value == true) {
                    setMessage({ text: "Drill-Thru Set Created Successfully", type: "success" })
                }
            }
        } catch (error) {
            console.error("Error during API call:", error);
            setMessage({ text: 'An error occurred while saving the data.', type: 'error' });
        }
    };


    return (
        <div>
            <div className="float-right margin-top-small">
                <a id="link_backto_admin_tasks" href={`${getBaseUrl()}/ux/index.html#AdminTasks`}>
                    « Back to Admin Tasks
                </a>
            </div>
            <h2>Confirmation Page</h2>
            {message.text && (
                <div className={`message ${message.type}`}>
                    {message.text}
                </div>
            )}
            <GenericTableforArrayofObjects items={tableData} />
            <div style={{ display: 'flex', marginTop: '1rem' }}>
                <FoundationsButton id={''} buttonClasses="ui-button ui-corner-all ui-widget app-button" onClick={handleBackToForm}>Cancel</FoundationsButton>
                <FoundationsButton id={''} buttonClasses="ui-button ui-corner-all ui-widget app-button" onClick={handleConfirm}>Confirm</FoundationsButton>
            </div>
        </div>
    );
};

export default ConfirmationPage;